module.exports = __webpack_public_path__ + "img/GS.df16932d.png";